import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import PortalIdParser from 'PortalIdParser';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Box } from 'foundations-components/transitional/components/Box';
import { useHasConfiguredCustomerAgent } from 'customer-agent-discovery-components-lib/data/customer-agents/useHasConfiguredCustomerAgent';
import { usageTracker } from '../../../usage-tracker/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomerAgentCTATile = () => {
  const location = useLocation();
  const shouldShowCTA = location.pathname.includes('/help-desk/');
  const {
    hasConfiguredAgent
  } = useHasConfiguredCustomerAgent();
  const portalId = PortalIdParser.get();
  const customerAgentLearnMoreUrl = `/customer-agent/${portalId}/onboarding`;
  const customerAgentCreateUrl = `/customer-agent/${portalId}/onboarding/setup`;
  const customerAgentTesterUrl = `/customer-agent-tester/${portalId}/?channel=email`;
  const handleButtonClick = () => {
    if (hasConfiguredAgent) {
      usageTracker.track('Conversations Message History', 'Click Test Agent', {
        action: 'click test agent',
        hasConfiguredAgent
      });
    } else {
      usageTracker.track('Conversations Message History', 'Click Create Agent', {
        action: 'click create agent',
        hasConfiguredAgent
      });
    }
  };
  const handleLearnMoreClick = () => {
    usageTracker.track('Conversations Message History', 'Click Learn More', {
      action: 'click learn more',
      hasConfiguredAgent
    });
  };
  if (!shouldShowCTA || hasConfiguredAgent === undefined) {
    return null;
  }
  return /*#__PURE__*/_jsx(Box, {
    padding: "300",
    marginBlockEnd: "300",
    children: /*#__PURE__*/_jsx(Tile, {
      compact: true,
      children: /*#__PURE__*/_jsx(TileSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          gap: "100",
          children: [/*#__PURE__*/_jsx(Text, {
            color: "text-core-subtle",
            as: "small",
            children: hasConfiguredAgent ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-message-history.customerAgentCTA.configured.description"
            }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "conversations-message-history.customerAgentCTA.notConfigured.description_jsx",
              elements: {
                Link
              },
              options: {
                href: customerAgentLearnMoreUrl,
                external: false,
                onClick: handleLearnMoreClick
              }
            })
          }), /*#__PURE__*/_jsx(Flex, {
            children: /*#__PURE__*/_jsx(Button, {
              use: "tertiary-light",
              size: "extra-small",
              href: hasConfiguredAgent ? customerAgentTesterUrl : customerAgentCreateUrl,
              external: true,
              hideExternalLinkIcon: true,
              onClick: handleButtonClick,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: hasConfiguredAgent ? 'conversations-message-history.customerAgentCTA.configured.testButton' : 'conversations-message-history.customerAgentCTA.notConfigured.createButton'
              })
            })
          })]
        })
      })
    })
  });
};
CustomerAgentCTATile.displayName = 'CustomerAgentCTATile';